module.exports = __webpack_public_path__ + "img/klaus-a1-2.8bd635ce.png";